.container {
  min-height: calc(var(--mirai-ui-space-L) * 4.75);
  max-height: calc(var(--mirai-ui-space-XXL) * 10);
  overflow-y: auto;
}

.checkout {
  padding: var(--mirai-ui-space-M);
  width: 100%;
}
